import { AddressBook } from "../../addressBook";
export const InvoiceOptions = () => <AddressBook kind="billing" />;
